const MeetingDoctorDomain = process.env.NODE_ENV === 'production' ? '.meetingdoctors.com' : 'localhost'

export const MeetingDoctorsCookieStrategy = {
  expires: 365,
  path: '/',
  domain: MeetingDoctorDomain,
  secure: true,
  sameSite: 'strict',
} as const

export type MeetingDoctorsCookieStrategy = typeof MeetingDoctorsCookieStrategy

export const CookieRepositoryStrategy = {
  MeetingDoctors: MeetingDoctorsCookieStrategy,
} as const
